export default "__VITE_ASSET__C882mnsf__"